export const DEFAULT = "generic";
export const CERTIFICATE = "certificate";
export const SPEAKER = "speaker";
export const CSS_MEDIA = "css_media";
export const CHANNEL = "channel";
export const CALENDAR = "calendar";
export const TICKET = "ticket"